<template>
  <div class="Index">
    <!-- <div class="content-box">
      <div class="go-back" @click="goback">返 回</div>
      <div class="routine-box"></div>
      <div class="routine-321"></div>
    </div> -->
    <div class="content-theme">
      <div class="content-theme-title">
        <div
          v-for="(item, index) in detailList"
          :key="index"
          :class="index === activeDetail ? 'active' : 'setting'"
          @click.stop.prevent="handleDetailToggle(index)"
        >
          {{ item.label }}
        </div>
      </div>
    </div>

    <div class="content-theme-content">
      <div class="content-theme-content-title">
        <div v-for="(item, index) in questionToggleList" :key="index">
          <div class="questionList-title" @click="pageJumpUrl(item.url)">
            <div class="questionList-title-img">
              <div class="questionList-title-img-title">Q{{ index + 1 }}</div>
            </div>
            <div>{{ item.label }}</div>
            <img
              v-if="index < 3"
              class="questionList-title-fire"
              src="@/assets/modify/list/fire.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <div class="toggle-list">
      <div class="toggle-list-card" @click="toggleCardMode">
        <img
          class="toggle-list-card-img"
          src="@/assets/modify/list/card.png"
          alt=""
        />
        <div class="toggle-list-card-title">切换为卡片模式</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'list',
  data () {
    return {
      detailList: [
        {
          label: '旅行与拍摄',
          questionList: [
            { label: '如何使用抖音购买景区门票？', url: '/travel/admissionFee/dy/index1' },
            { label: '如何使用携程购买景区门票？', url: '/travel/admissionFee/xc/index1' },
            { label: '如何使用美团购买景区门票？', url: '/travel/admissionFee/mt/index1' },

            { label: '如何使用抖音预订酒店房间？', url: '/travel/hotel/dy/index1' },
            { label: '如何使用携程预订酒店房间？', url: '/travel/hotel/xc/index1' },
            { label: '如何使用美团预订酒店房间？', url: '/travel/hotel/mt/index1' },
            {
              label: '如何使用美团报旅行团？',
              url: '/travel/group/mt/index1'
            },
            {
              label: '如何使用携程报旅行团？',
              url: '/travel/group/xc/index1'
            },

            { label: '如何使用手机原生相机拍照片？', url: '/travel/photo/index1' },
            { label: '如何使用手机原生相机拍视频？', url: '/travel/video/index1' }
          ]
        },
        {
          label: '修图编辑',
          questionList: [
            {
              label: '如何在修图和剪视频时对人物美颜？',
              url: '/edit/beautiful/index'
            },
            {
              label: '如何在修图和剪视频时对人物瘦身美体？',
              url: '/edit/slimming/index'
            },
            {
              label: '如何在修图和剪视频时对景物调色？',
              url: '/edit/toning/index'
            },
            {
              label: '如何在修图和剪视频时添加文字？',
              url: '/edit/add/index'
            },
            {
              label: '如何使用拼图工具将多张照片拼接？',
              url: '/edit/picture/index1'
            },
            {
              label: '如何在剪映中裁剪视频素材？',
              url: '/edit/videoClips/clip/index1'
            },
            {
              label: '如何在剪映中添加动画和转场？',
              url: '/edit/videoClips/animation/index1'
            },
            {
              label: '如何在剪映中添加关键帧？',
              url: '/edit/videoEditing/keyframe/index1'
            },
            {
              label: '如何在剪映中添加画中画？',
              url: '/edit/videoEditing/picture/index1'
            },
            {
              label: '如何在剪映使用AI剪视频？',
              url: '/edit/ai/jsp/index1'
            },
            {
              label: '如何在剪映使用AI生成配音？',
              url: '/edit/ai/py/index1'
            },
            {
              label: '如何在剪映使用AI图文成片？',
              url: '/edit/ai/twcp/index1'
            },
            {
              label: '如何在剪映使用热门模板一键成片？',
              url: '/edit/ai/yjcp/index1'
            }
          ]
        },
        {
          label: '智能生活',
          questionList: [
            {
              label: '如何在手机上查看摄像头监控的画面？',
              url: '/smartLife/monitor/index1'
            },
            {
              label: '如何在手机上生成指纹锁的临时密码？',
              url: '/smartLife/lock/index1'
            },
            {
              label: '如何使用豆包AI助手？',
              url: '/smartLife/partner/db/index1'
            },
            {
              label: '如何使用讯飞晓医助手？',
              url: '/smartLife/partner/xf/index1'
            },
            {
              label: '如何用豆包写作？',
              url: '/smartLife/AIWriting/db/index1'
            },
            {
              label: '如何用deepseek写作？',
              url: '/smartLife/AIWriting/dp/index1'
            },
            {
              label: '如何用豆包生成图片？',
              url: '/smartLife/AIGeneratedImages/db/index1'
            },
            {
              label: '如何用即梦生成图片？',
              url: '/smartLife/AIGeneratedImages/jm/index1'
            },
            {
              label: '如何用豆包生成视频？',
              url: '/smartLife/AIGeneratedVideos/jm/index1'
            },
            {
              label: '如何用即梦生成视频？',
              url: '/smartLife/AIGeneratedVideos/db/index1'
            },
            {
              label: '如何用豆包生成写真照？',
              url: '/smartLife/AIPhotography/db/index1'
            },
            {
              label: '如何用即梦生成写真照？',
              url: '/smartLife/AIPhotography/jm/index1'
            },
            {
              label: '如何用豆包生成音乐？',
              url: '/smartLife/AIMusic/db/index1'
            },
            {
              label: '如何用豆包修图？',
              url: '/smartLife/AIMusic/suno/index1'
            },
            {
              label: '如何用即梦修图？',
              url: '/smartLife/AIImageEditing/db/index1'
            },
            {
              label: '如何用豆包生成音乐？',
              url: '/smartLife/AIImageEditing/jm/index1'
            },
            {
              label: '如何用即梦生成数字人？',
              url: '/smartLife/AIDigitalHuman/jm/index1'
            }
          ]
        },
        {
          label: '休闲娱乐',
          questionList: [
            {
              label: '如何使用抖音录制视频并发布作品？',
              url: '/entertainment/publishWorks/dy/branch1/index1'
            },
            {
              label: '如何使用抖音拍同款快速发布模板视频？',
              url: '/entertainment/publishWorks/dy/index1'
            },
            {
              label: '如何使用抖音的剪辑功能调整视频素材？',
              url: '/entertainment/publishWorks/dy/branch2/index1'
            },
            {
              label: '如何对抖音发布的作品设置查看权限？',
              url: '/entertainment/publishWorks/dy/branch3/index1'
            },
            {
              label: '如何在美篇发布一篇文章？',
              url: '/entertainment/publishWorks/mp/index1'
            },
            {
              label: '如何在小红书发布视频作品？',
              url: '/entertainment/publishWorks/xhs/index1'
            },
            {
              label: '如何在抖音与作品互动？',
              url: '/entertainment/followWorks/dy/index1'
            },
            {
              label: '如何在抖音关注作者？',
              url: '/entertainment/followWorks/dy/branch/index1'
            },
            {
              label: '如何在小红书与作品互动？',
              url: '/entertainment/followWorks/xhs/index1'
            },
            {
              label: '如何在小红书关注作者？',
              url: '/entertainment/followWorks/xhs/branch/index1'
            },
            {
              label: '如何在美篇与作品互动？',
              url: '/entertainment/followWorks/mp/index1'
            },
            {
              label: '如何在美篇关注作者？',
              url: '/entertainment/followWorks/mp/branch/index1'
            },
            {
              label: '如何在抖音开直播？',
              url: '/entertainment/liveBroadcast/dy/index1'
            },
            {
              label: '如何在抖音直播时开启美颜？',
              url: '/entertainment/liveBroadcast/dy/branch2/index1'
            },
            {
              label: '如何在抖音直播前完成实名认证？',
              url: '/entertainment/liveBroadcast/dy/branch1/index1'
            },
            {
              label: '如何在视频号开直播？',
              url: '/entertainment/liveBroadcast/wx/index1'
            },
            {
              label: '如何在视频号直播前完成实名认证？',
              url: '/entertainment/liveBroadcast/wx/branch1/index1'
            },
            {
              label: '如何在视频号直播时开启美颜？',
              url: '/entertainment/liveBroadcast/wx/branch2/index1'
            },
            {
              label: '如何在视频号直播时使用工具？',
              url: '/entertainment/liveBroadcast/wx/branch3/index1'
            },
            {
              label: '如何在小红书开直播？',
              url: '/entertainment/liveBroadcast/xhs/index1'
            },
            {
              label: '如何在小红书直播时开启美颜？',
              url: '/entertainment/liveBroadcast/xhs/branch2/index1'
            },
            {
              label: '如何在小红书直播前完成实名认证？',
              url: '/entertainment/liveBroadcast/xhs/branch1/index1'
            },
            { label: '如何在手机上K歌？', url: '/entertainment/song/index' },
            {
              label: '如何在手机上听电子书？',
              url: '/entertainment/hear/index'
            },
            {
              label: '如何在手机上看电视剧？',
              url: '/entertainment/see/index'
            },
            {
              label: '如何用手机购买电影票？',
              url: '/entertainment/film/index'
            }
          ]
        },
        {
          label: '老有所学',
          questionList: [
            // {
            //   label: "如何在手机上查看合肥终身学习网？",
            //   url: "/study/HeFei/index",
            // },
            // {
            //   label: "如何在手机上查看安徽老年远程教育网？",
            //   url: "/study/AnHui/index",
            // },
            {
              label: '如何学习国家老年大学网站上的国医名师课？',
              url: '/study/country/course1/index1'
            },
            {
              label: '如何在国家老年大学网站学习课程？',
              url: '/study/country/course1/index2'
            },
            {
              label: '如何在国家老年大学网站进行线上学习？',
              url: '/study/country/course1/index3'
            },
            {
              label: '如何报名并学习国家老年大学的云课堂？',
              url: '/study/country/course1/index4'
            }
          ]
        }
      ],
      // 激活对象
      activeDetail: 0,
      // 问题列表
      questionToggleList: [
        { label: '如何使用抖音购买景区门票？', url: '/travel/admissionFee/dy/index1' },
        { label: '如何使用携程购买景区门票？', url: '/travel/admissionFee/xc/index1' },
        { label: '如何使用美团购买景区门票？', url: '/travel/admissionFee/mt/index1' },

        { label: '如何使用抖音预订酒店房间？', url: '/travel/hotel/dy/index1' },
        { label: '如何使用携程预订酒店房间？', url: '/travel/hotel/xc/index1' },
        { label: '如何使用美团预订酒店房间？', url: '/travel/hotel/mt/index1' },
        {
          label: '如何使用美团报旅行团？',
          url: '/travel/group/mt/index1'
        },
        {
          label: '如何使用携程报旅行团？',
          url: '/travel/group/xc/index1'
        },

        { label: '如何使用手机原生相机拍照片？', url: '/travel/photo/index1' },
        { label: '如何使用手机原生相机拍视频？', url: '/travel/video/index1' }
      ]
    }
  },
  methods: {
    goback () {
      this.$router.replace({
        path: '/classification'
      })
    },
    handleDetailToggle (index) {
      this.activeDetail = index
      this.questionToggleList = this.detailList[index].questionList
    },
    toggleCardMode () {
      this.$router.replace({
        path: '/classification'
      })
    },
    pageJumpUrl (url) {
      this.$router.push({
        path: url
      })
    }
  }
}
</script>

<style scoped lang="less">
.Index {
  position: relative;
  width: 100%;
  height: 100%;
  background: url(@/assets/modify/mainBg/rectangle_20250106.png) no-repeat
    center;
  background-size: 100% 100%;
  border-radius: 0px;
}
.content-box {
  display: flex;
  justify-content: space-evenly;
  padding-top: 40px;
  box-sizing: border-box;
}

.content-theme {
  width: 100%;
  .content-theme-title {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    font-size: 25px;
    padding-top: 70px;
    box-sizing: border-box;
  }
}
.setting {
  color: rgb(255, 75, 83);
  width: 122px;
  height: 75px;
  text-align: center;
  background: url(@/assets/modify/list/group-11-2.png) no-repeat;
  background-size: 100% 100%;
  font-weight: bold;
  //超出两行省略号
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  -webkit-line-clamp: 2; //显示几行
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 15px;
  box-sizing: border-box;
  border: 1px solid rgb(255, 152, 152);
  box-shadow: 0px 8px 17px 0px rgba(228, 123, 123, 0.35);
}
.active {
  color: rgb(255, 255, 255);
  width: 122px;
  height: 75px;
  text-align: center;
  background: url(@/assets/modify/list/group-11.png) no-repeat;
  background-size: 100% 100%;
  font-weight: bold;
  //超出两行省略号
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  -webkit-line-clamp: 2; //显示几行
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  border-radius: 15px;
  box-sizing: border-box;
  border: 1px solid rgb(255, 198, 201);
  box-shadow: 0px 8px 17px 0px rgba(241, 90, 97, 0.51);
}
.content-theme-content {
  width: 95%;
  height: 70%;
  margin: 0 auto;
  overflow-y: auto;
  margin-top: 40px;
}
.content-theme-content-title {
  // height: 100%;
  margin: 0 30px;
  box-sizing: border-box;
}
.questionList-title {
  border-radius: 15px;
  box-shadow: 0px 14px 23px -9px rgba(0, 0, 0, 0.09);
  background: rgb(255, 255, 255);
  width: 100%;
  height: 90px;
  font-size: 30px;
  color: #373737;
  box-sizing: border-box;
  display: flex;
  margin-top: 20px;
  align-items: center;
}
.questionList-title-fire {
  width: 35px;
  height: 35px;
  margin-left: 15px;
  // margin-top: 12px;
}
.questionList-title-img {
  width: 45px;
  height: 45px;
  margin: 0px 20px 0 30px;
  background: url(@/assets/modify/list/group-4.png) no-repeat center;
  background-size: 100% 100%;
}
.questionList-title-img-title {
  color: #d3f0e1;
  margin-top: 7px;
  font-size: 16px;
  margin-left: 6px;
}
.toggle-list {
  // margin: 15px 0;
}
.toggle-list-card {
  width: 60%;
  height: 100px;
  line-height: 100px;
  margin: 0 auto;
  background: url(@/assets/modify/list/group-26.png) no-repeat center;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 35px;
  color: #ffffff;
  margin-top: 40px;
}
.toggle-list-card-img {
  width: 50px;
  height: 50px;
  margin-right: 10px;
}
</style>
